import _ from 'lodash';
import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  page: 'order',
  
  pickupAddress: false,
  pickupLat: false,
  pickupLong: false,
  pickupDate: false,
  pickupTime: false,

  dropoffAddress: false,
  dropoffLat: false,
  dropoffLong: false,
  dropoffDate: false,
  dropoffTime: false,

  bagsCount: false,
  bagTitles: [],
  bagDescs: [],
  errorText: false,
  couponCode: false,
  promocodeStatus: false,

  priceBlockHidden: true,
  transportFee: 0.00,
  storageFee: 0.00,
  insuranceFee: 0.00,
  taxRate: 0.00,
  tax: 0.00,
  total: 0.00,
  discount: false,

  referralCode: false,
  
  bottom: false,
  loading: false,

  pickupAirport: false,
  pickupAirportTerminal: false,
  dropoffAirport: false,
  dropoffAirportTerminal: false,

  insurance: false,

  errorPickupAddress: false,
  errorPickupDate: false,
  errorPickupTime: false,
  errorDropoffAddress: false,
  errorDropoffDate: false,
  errorDropoffTime: false,
  errorDropoffInstructions: false,
  errorBag1Title: false,
  errorBag1Desc: false,
  errorBag2Title: false,
  errorBag2Desc: false,
  errorBag3Title: false,
  errorBag3Desc: false,
  errorBag4Title: false,
  errorBag4Desc: false,
  errorBag5Title: false,
  errorBag5Desc: false,

  errorFirstName: false,
  errorLastName: false,
  errorPhone: false,
  errorEmail: false,
  errorCard: false,

  errorPickupTerminal: false,
  errorDropoffTerminal: false,

  referralLogo: false
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.PAGE_SET:
      return state.merge({
        page: action.page
      });
    case types.PICKUP_ADDRESS_SELECTED:
      return state.merge({
        pickupAddress: action.address
      });
    case types.PICKUP_COORDINATES_SELECTED:
      return state.merge({
        pickupLat: action.lat,
        pickupLong: action.lng
      });
    case types.PICKUP_DATE_SELECTED:
      return state.merge({
        pickupDate: action.date,
      });
    case types.PICKUP_TIME_SELECTED:
      return state.merge({
        pickupTime: action.time
      });
    case types.DROPOFF_ADDRESS_SELECTED:
      return state.merge({
        dropoffAddress: action.address
      });
    case types.DROPOFF_COORDINATES_SELECTED:
      return state.merge({
        dropoffLat: action.lat,
        dropoffLong: action.lng
      });
    case types.DROPOFF_DATE_SELECTED:
      return state.merge({
        dropoffDate: action.date,
      });
    case types.DROPOFF_TIME_SELECTED:
      return state.merge({
        dropoffTime: action.time
      });
    case types.DROPOFF_INSTRUCTIONS_SELECTED:
      return state.merge({
        instructions: action.instructions
      });
    case types.BAGS_COUNT_SET:
      return state.merge({
        bagsCount: action.count
      });
    case types.ERROR_TEXT:
      return state.merge({
        errorText: action.text
      });
    case types.COUPON_CODE_SET:
      return state.merge({
        couponCode: action.couponCode
      });
    case types.PROMOCODE_STATUS_SET:
      return state.merge({
        promocodeStatus: action.status
      });
    case types.BAGS_I_TITLE_SET:
      var edited_bag_titles = [];
      _.forOwn(state.bagTitles, function(value, key) {
        edited_bag_titles[key] = value;
      });
      edited_bag_titles[action.i] = action.title;
      return state.merge({
        bagTitles: edited_bag_titles
      });
    case types.BAGS_I_DESC_SET:
      var edited_bag_descs = [];
      _.forOwn(state.bagDescs, function(value, key) {
        edited_bag_descs[key] = value;
      });
      edited_bag_descs[action.i] = action.desc;
      return state.merge({
        bagDescs: edited_bag_descs
      });
    case types.PRICE_BLOCK_VISIBILITY_SET:
      return state.merge({
        priceBlockHidden: action.hidden
      });
    case types.PRICE_SET:
      return state.merge({
        transportFee: action.transportFee,
        storageFee: action.storageFee,
        insuranceFee: action.insuranceFee,
        taxRate: action.taxRate,
        tax: action.tax,
        total: action.total,
        discount: action.discount,
      });
    case types.REFERRAL_CODE_SET:
      return state.merge({
        referralCode: action.code
      });
    case types.BOTTOM_SET:
      return state.merge({
        bottom: action.value
      });
    case types.LOADING_SET:
      return state.merge({
        loading: action.value
      });
    
    case types.PICKUP_AIRPORT_SET:
      return state.merge({
        pickupAirport: action.value
      });
    case types.PICKUP_AIRPORT_TERMINAL_SET:
      return state.merge({
        pickupAirportTerminal: action.value
      });
    case types.DROPOFF_AIRPORT_SET:
      return state.merge({
        dropoffAirport: action.value
      });
    case types.DROPOFF_AIRPORT_TERMINAL_SET:
      return state.merge({
        dropoffAirportTerminal: action.value
      });
    case types.INSURANCE_SET:
      return state.merge({
        insurance: action.value
      });
    case types.ERROR_FIELD_SET:
      if (action.errorPickupAddress !== undefined) {
        return state.merge({
          errorPickupAddress: action.errorPickupAddress
        });
      }
      if (action.errorPickupDate !== undefined) {
        return state.merge({
          errorPickupDate: action.errorPickupDate
        });
      }
      if (action.errorPickupTime !== undefined) {
        return state.merge({
          errorPickupTime: action.errorPickupTime
        });
      }
      if (action.errorDropoffAddress !== undefined) {
        return state.merge({
          errorDropoffAddress: action.errorDropoffAddress
        });
      }
      if (action.errorDropoffDate !== undefined) {
        return state.merge({
          errorDropoffDate: action.errorDropoffDate
        });
      }
      if (action.errorDropoffTime !== undefined) {
        return state.merge({
          errorDropoffTime: action.errorDropoffTime
        });
      }
      if (action.errorDropoffInstructions !== undefined) {
        return state.merge({
          errorDropoffInstructions: action.errorDropoffInstructions
        });
      }
      if (action.errorBag1Title !== undefined) {
        return state.merge({
          errorBag1Title: action.errorBag1Title
        });
      }
      if (action.errorBag1Desc !== undefined) {
        return state.merge({
          errorBag1Desc: action.errorBag1Desc
        });
      }
      if (action.errorBag2Title !== undefined) {
        return state.merge({
          errorBag2Title: action.errorBag2Title
        });
      }
      if (action.errorBag2Desc !== undefined) {
        return state.merge({
          errorBag2Desc: action.errorBag2Desc
        });
      }
      if (action.errorBag3Title !== undefined) {
        return state.merge({
          errorBag3Title: action.errorBag3Title
        });
      }
      if (action.errorBag3Desc !== undefined) {
        return state.merge({
          errorBag3Desc: action.errorBag3Desc
        });
      }
      if (action.errorBag4Title !== undefined) {
        return state.merge({
          errorBag4Title: action.errorBag4Title
        });
      }
      if (action.errorBag4Desc !== undefined) {
        return state.merge({
          errorBag4Desc: action.errorBag4Desc
        });
      }
      if (action.errorBag5Title !== undefined) {
        return state.merge({
          errorBag5Title: action.errorBag5Title
        });
      }
      if (action.errorBag5Desc !== undefined) {
        return state.merge({
          errorBag5Desc: action.errorBag5Desc
        });
      }
      if (action.errorFirstName !== undefined) {
        return state.merge({
          errorFirstName: action.errorFirstName
        });
      }
      if (action.errorLastName !== undefined) {
        return state.merge({
          errorLastName: action.errorLastName
        });
      }
      if (action.errorPhone !== undefined) {
        return state.merge({
          errorPhone: action.errorPhone
        });
      }
      if (action.errorEmail !== undefined) {
        return state.merge({
          errorEmail: action.errorEmail
        });
      }
      if (action.errorPickupTerminal !== undefined) {
        return state.merge({
          errorPickupTerminal: action.errorPickupTerminal
        });
      }
      if (action.errorDropoffTerminal !== undefined) {
        return state.merge({
          errorDropoffTerminal: action.errorDropoffTerminal
        });
      }
      if (action.errorCard !== undefined) {
        return state.merge({
          errorCard: action.errorCard
        });
      }
      break;
      
    case types.REFERRAL_LOGO_SET:
      return state.merge({
        referralLogo: action.value
      });
      
    default:
      return state;
  }
}

// selectors
export function getPage(state) {
  return state.order.page;
}

export function getBagsCount(state) {
  return state.order.bagsCount;
}

export function getErrorText(state) {
  return state.order.errorText;
}

export function getCouponCode(state) {
  return state.order.couponCode;
}

export function getBagTitles(state) {
  return state.order.bagTitles;
}

export function getBagDescs(state) {
  return state.order.bagDescs;
}

export function getPromocodeStatus(state) {
  return state.order.promocodeStatus;
}

export function getInsurance(state) {
  return state.order.insurance;
}

export function getDate(state, type) {
  switch (type) {
    case 'pickup':
      return state.order.pickupDate;
    case 'dropoff':
      return state.order.dropoffDate;
    default:
      return '';
  }
}

export function getTime(state, type) {
  switch (type) {
    case 'pickup':
      return state.order.pickupTime;
    case 'dropoff':
      return state.order.dropoffTime;
    default:
      return '';
  }
}

export function getCoordinate(state, type) {
  switch (type) {
    case 'pickup':
      return {lat: state.order.pickupLat, long: state.order.pickupLong};
    case 'dropoff':
      return {lat: state.order.dropoffLat, long: state.order.dropoffLong};
    default:
      return {};
  }
}

export function getAddress(state, type) {
  switch (type) {
    case 'pickup':
      return state.order.pickupAddress;
    case 'dropoff':
      return state.order.dropoffAddress;
    default:
      return {};
  }
}

export function getPriceBlockHidden(state) {
  return state.order.priceBlockHidden;
}

export function getPrice(state) {
  return {
    transportFee: state.order.transportFee,
    storageFee: state.order.storageFee,
    insuranceFee: state.order.insuranceFee,
    taxRate: state.order.taxRate,
    tax: state.order.tax,
    total: state.order.total,
    discount: state.order.discount
  };
}

export function getDropoffInstructions(state) {
  return state.order.instructions;
}

export function getReferralCode(state) {
  return state.order.referralCode;
}

export function getBottom(state) {
  return state.order.bottom;
}

export function getLoading(state) {
  return state.order.loading;
}


export function getPickupAirport(state) {
  return state.order.pickupAirport;
}

export function getPickupAirportTerminal(state) {
  return state.order.pickupAirportTerminal;
}

export function getDropoffAirport(state) {
  return state.order.dropoffAirport;
}

export function getDropoffAirportTerminal(state) {
  return state.order.dropoffAirportTerminal;
}

export function getErrorField(state, field) {
  return state.order[field];
}

export function getReferralLogo(state) {
  return state.order.referralLogo;
}